import lozad from 'lozad';

// reCAPTCHA v3 used to load on every page in the footer. Now the protected forms
// ask for it themselves: lozad warms it up when the form scrolls into view, and
// the submit handler awaits the same promise in case it never did.
let loading;

export function loadRecaptcha() {
    if (!loading) {
        loading = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://www.google.com/recaptcha/api.js?render=' + window.gRecaptchaKey;
            script.async = true;
            script.onload = () => window.grecaptcha.ready(resolve);
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }
    return loading;
}

// call with the protected form, nothing loads until it is on screen
export function observeForm(form) {
    if (!form) return;
    lozad(form, { load: loadRecaptcha }).observe();
}
